import { ClientError, type Variables } from 'graphql-request'
import { getDataCMS } from '../service/cms'
import { useQuery, UseQueryOptions } from 'react-query'

interface UseGetProps<Data> extends UseQueryOptions<Data, ClientError, Data> {
  query: string
  variables?: Variables
}

export const useGetDataCMS = <Data>({
  query,
  variables = {},
  ...props
}: UseGetProps<Data>) =>
  useQuery<Data, ClientError, Data>({
    queryFn: () => getDataCMS<Data>(query, variables),
    ...props,
  })
